import * as React from "react";

import {
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { ConditionAnalysisSlice } from "../../../../utils/conditionAnalysisSelectors";
import {
  regimeDrilldownTableDescription,
  regimeDrilldownTableTitle,
} from "../../../../utils/marketContextDrilldownLabels";
import {
  breakdownMapToSliceKind,
  getExplorerCategoryLabel,
  getExplorerCategoryShortLabel,
} from "../marketContextSliceDisplay";
import { MarketContextSliceCategoryBadge } from "./MarketContextSliceCategoryBadge";
import {
  METRIC_TOOLTIP_BODY_CLASS,
  METRIC_TOOLTIP_TITLE_CLASS,
} from "@/components/ui/metric-tooltip";
import { MarketContextTooltipContent } from "./marketContextDataTableShared";

export function ExitPlacementCategoryBadge(props: {
  breakdownMap: string;
  candleTimeframe?: string | null;
}): React.ReactElement {
  const breakdownMap = props.breakdownMap.trim();
  if (!breakdownMap) {
    return <span className="text-sm text-muted-foreground">—</span>;
  }

  const tf = props.candleTimeframe;
  const slice = { kind: breakdownMapToSliceKind(breakdownMap) } as ConditionAnalysisSlice;
  const shortLabel = getExplorerCategoryShortLabel(breakdownMap, tf);
  const fullLabel = getExplorerCategoryLabel(breakdownMap, tf);
  const tableTitle = regimeDrilldownTableTitle(breakdownMap, tf);
  const description = regimeDrilldownTableDescription(breakdownMap, tf);
  const showFullLabelInTooltip = fullLabel !== shortLabel;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex max-w-full cursor-help" data-no-row-click="">
            <MarketContextSliceCategoryBadge
              slice={slice}
              label={shortLabel}
              withTooltip={false}
              candleTimeframe={tf}
            />
          </span>
        </TooltipTrigger>
        <MarketContextTooltipContent widthClass="max-w-[300px]">
          {showFullLabelInTooltip ? (
            <p className={METRIC_TOOLTIP_TITLE_CLASS}>{fullLabel}</p>
          ) : (
            <p className={METRIC_TOOLTIP_TITLE_CLASS}>{tableTitle}</p>
          )}
          <p className={`mt-1 text-[11px] leading-snug ${METRIC_TOOLTIP_BODY_CLASS}`}>{description}</p>
        </MarketContextTooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
